






	import Vue from 'vue';
    import ModListUserBodyRoleComp from "./ModListUserBodyRoleComp.vue";

    export default Vue.extend({
        name: "ModListUserBodyRolesComp",
        components: {ModListUserBodyRoleComp},
        props: ['roles']
    })
